let MemberCard = function (tokenClient, serviceAddr) {
    let TokenClient = tokenClient
    let ServiceBaseAddress = serviceAddr

    /**
     * 机构后台-分页查询会员卡批次列表
     * @param {*} versionName 
     * @param {*} success
     * @param {*} error
     */
    this.GetOrgMemberCardBatchList = function (versionName, startTime, endTime, pageSize, pageIndex, success, error) {
        var url = ServiceBaseAddress + '/api/MemberCard/GetOrgMemberCardBatchList';
        if (versionName) {
            url += '/' + versionName
        } else {
            url += '/%20'
        }
        if (startTime) {
            url += '/' + startTime
        }
        else {
            url += '/%20'
        }
        if (endTime) {
            url += '/' + endTime
        } else {
            url += '/%20'
        }
        if (pageSize) {
            url += '/' + pageSize
        }
        else {
            url += '/1'
        }
        if (pageIndex) {
            url += '/' + pageIndex
        }
        else {
            url += '/15'
        }
        TokenClient.Get(
            url,
            true,
            null,
            null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }

    /**
    * 机构后台-分页查询会员卡详细列表
    * @param {*} versionName 
    * @param {*} success 
    * @param {*} error 
    */
    this.GetOrgMemberCardDetailList = function (batchId, cardStatus, cardCode, versionName, sort, startTime, endTime, pageIndex, pageSize, success, error) {
        var url = ServiceBaseAddress + '/api/MemberCard/GetOrgMemberCardDetailList';
        if (batchId) {
            url += '/' + batchId
        }
        else {
            url += '/0'
        }
        
        url += '/' + cardStatus

        if (cardCode) {
            url += '/' + cardCode
        }
        else {
            url += '/%20'
        }
        if (versionName) {
            url += '/' + versionName
        } else {
            url += '/%20'
        }
        if (sort) {
            url += '/' + sort
        } else {
            url += '/0'
        }
        if (startTime) {
            url += '/' + startTime
        }
        else {
            url += '/%20'
        }
        if (endTime) {
            url += '/' + endTime
        }
        else {
            url += '/%20'
        }
        if (pageIndex) {
            url += '/' + pageIndex
        }
        else {
            url += '/1'
        }
        if (pageSize) {
            url += '/' + pageSize
        }
        else {
            url += '/15'
        }
        TokenClient.Get(
            url,
            true,
            null,
            null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }
}

export { MemberCard }
